import React from 'react';
import { User, BookOpen, Award, MapPin, Mail, ExternalLink, Star } from 'lucide-react';

const Authors = () => {
  const authors = [
    {
      name: "Dr. Sarah Johnson",
      title: "Professor of Computer Science",
      institution: "MIT",
      location: "Boston, USA",
      publications: 45,
      citations: 1250,
      hIndex: 18,
      specialization: "Artificial Intelligence, Machine Learning",
      image: "https://images.unsplash.com/photo-1494790108755-2616b612b786?ixlib=rb-4.0.3&auto=format&fit=crop&w=300&q=80",
      rating: 4.9,
      awards: ["IEEE Fellow", "ACM Distinguished Scientist"]
    },
    {
      name: "Prof. Michael Chen",
      title: "Dean of Engineering",
      institution: "Stanford University",
      location: "California, USA",
      publications: 62,
      citations: 2100,
      hIndex: 25,
      specialization: "Sustainable Technology, Environmental Engineering",
      image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-4.0.3&auto=format&fit=crop&w=300&q=80",
      rating: 4.8,
      awards: ["National Science Foundation Award", "Green Tech Pioneer"]
    },
    {
      name: "Dr. Emily Rodriguez",
      title: "Research Director",
      institution: "Google Research",
      location: "Mountain View, USA",
      publications: 38,
      citations: 980,
      hIndex: 16,
      specialization: "Natural Language Processing, Deep Learning",
      image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-4.0.3&auto=format&fit=crop&w=300&q=80",
      rating: 4.7,
      awards: ["Google Research Excellence", "AI Innovation Award"]
    },
    {
      name: "Prof. David Kim",
      title: "Head of Research",
      institution: "Seoul National University",
      location: "Seoul, South Korea",
      publications: 55,
      citations: 1800,
      hIndex: 22,
      specialization: "Robotics, Computer Vision",
      image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=300&q=80",
      rating: 4.9,
      awards: ["Robotics Excellence Award", "IEEE Outstanding Researcher"]
    },
    {
      name: "Dr. Priya Sharma",
      title: "Senior Research Scientist",
      institution: "IIT Delhi",
      location: "New Delhi, India",
      publications: 42,
      citations: 1150,
      hIndex: 19,
      specialization: "Quantum Computing, Cryptography",
      image: "https://images.unsplash.com/photo-1580489944761-15a19d654956?ixlib=rb-4.0.3&auto=format&fit=crop&w=300&q=80",
      rating: 4.8,
      awards: ["Quantum Research Excellence", "Women in Tech Leadership"]
    },
    {
      name: "Prof. James Wilson",
      title: "Director of Innovation",
      institution: "Oxford University",
      location: "Oxford, UK",
      publications: 58,
      citations: 1950,
      hIndex: 24,
      specialization: "Biomedical Engineering, Healthcare Technology",
      image: "https://images.unsplash.com/photo-1560250097-0b93528c311a?ixlib=rb-4.0.3&auto=format&fit=crop&w=300&q=80",
      rating: 4.9,
      awards: ["Medical Innovation Award", "Royal Society Fellowship"]
    }
  ];

  return (
    <div style={{ backgroundColor: '#f8fafc', minHeight: '100vh' }}>
      {/* Hero Section */}
      <section className="hero-section text-center" style={{ 
        background: 'linear-gradient(135deg, rgba(99, 102, 241, 0.9), rgba(168, 85, 247, 0.9)), url("https://images.unsplash.com/photo-1522202176988-66273c2fd55f?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80")',
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }}>
        <div className="container-custom">
          <h1 className="heading-1 text-white mb-6">Distinguished Authors & Researchers</h1>
          <p className="body-large text-white mb-8" style={{ maxWidth: '700px', margin: '0 auto 2rem', opacity: 0.95 }}>
            Meet our esteemed community of world-renowned researchers, academics, and thought leaders driving innovation across diverse fields
          </p>
          <div style={{ display: 'flex', justifyContent: 'center', gap: '40px', flexWrap: 'wrap', marginTop: '40px' }}>
            <div style={{ textAlign: 'center', color: 'white' }}>
              <div style={{ fontSize: '2.5rem', fontWeight: 700 }}>500+</div>
              <div style={{ opacity: 0.9 }}>Active Authors</div>
            </div>
            <div style={{ textAlign: 'center', color: 'white' }}>
              <div style={{ fontSize: '2.5rem', fontWeight: 700 }}>50+</div>
              <div style={{ opacity: 0.9 }}>Countries</div>
            </div>
            <div style={{ textAlign: 'center', color: 'white' }}>
              <div style={{ fontSize: '2.5rem', fontWeight: 700 }}>10K+</div>
              <div style={{ opacity: 0.9 }}>Publications</div>
            </div>
          </div>
        </div>
      </section>

      <div className="container-custom" style={{ padding: '80px 24px' }}>
        {/* Featured Authors */}
        <div style={{ marginBottom: '80px' }}>
          <h2 style={{ 
            textAlign: 'center', 
            marginBottom: '20px', 
            color: '#2d3748', 
            fontSize: '2.5rem', 
            fontWeight: 700 
          }}>
            Featured Authors
          </h2>
          <p style={{ 
            textAlign: 'center', 
            marginBottom: '60px', 
            color: '#718096', 
            fontSize: '1.2rem',
            maxWidth: '600px',
            margin: '0 auto 60px'
          }}>
            Discover the brilliant minds behind groundbreaking research and innovation
          </p>
          
          <div style={{ 
            display: 'grid', 
            gridTemplateColumns: 'repeat(auto-fit, minmax(380px, 1fr))', 
            gap: '40px' 
          }}>
            {authors.map((author, index) => (
              <div key={index} style={{ 
                background: 'linear-gradient(135deg, #667eea20 0%, #764ba210 100%)',
                padding: '3px',
                borderRadius: '20px',
                boxShadow: '0 10px 40px rgba(0,0,0,0.1)',
                transition: 'transform 0.3s ease'
              }}
              onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-8px)'}
              onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}>
                <div style={{ 
                  backgroundColor: 'white', 
                  borderRadius: '17px',
                  padding: '40px',
                  textAlign: 'center'
                }}>
                  {/* Author Image with Badge */}
                  <div style={{ position: 'relative', display: 'inline-block', marginBottom: '25px' }}>
                    <img 
                      src={author.image} 
                      alt={author.name}
                      style={{ 
                        width: '140px', 
                        height: '140px', 
                        borderRadius: '50%',
                        objectFit: 'cover',
                        border: '4px solid #667eea'
                      }}
                    />
                    <div style={{
                      position: 'absolute',
                      top: '-5px',
                      right: '10px',
                      backgroundColor: '#ffd700',
                      borderRadius: '50%',
                      width: '40px',
                      height: '40px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      boxShadow: '0 4px 12px rgba(255, 215, 0, 0.3)'
                    }}>
                      <Star size={20} color="white" fill="white" />
                    </div>
                  </div>
                  
                  {/* Author Info */}
                  <h3 style={{ 
                    color: '#2d3748', 
                    fontSize: '1.5rem', 
                    fontWeight: 700, 
                    marginBottom: '8px' 
                  }}>
                    {author.name}
                  </h3>
                  
                  <p style={{ 
                    color: '#667eea', 
                    fontWeight: 600, 
                    fontSize: '1.1rem',
                    marginBottom: '6px' 
                  }}>
                    {author.title}
                  </p>
                  
                  <p style={{ 
                    color: '#4a5568', 
                    fontWeight: 600,
                    marginBottom: '15px' 
                  }}>
                    {author.institution}
                  </p>
                  
                  <div style={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    justifyContent: 'center', 
                    gap: '8px', 
                    marginBottom: '25px' 
                  }}>
                    <MapPin size={16} color="#718096" />
                    <span style={{ fontSize: '0.95rem', color: '#718096', fontWeight: 500 }}>
                      {author.location}
                    </span>
                  </div>

                  {/* Rating */}
                  <div style={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    justifyContent: 'center', 
                    gap: '8px', 
                    marginBottom: '25px' 
                  }}>
                    <div style={{ display: 'flex', gap: '2px' }}>
                      {[...Array(5)].map((_, i) => (
                        <Star 
                          key={i} 
                          size={16} 
                          color={i < Math.floor(author.rating) ? '#ffd700' : '#e2e8f0'}
                          fill={i < Math.floor(author.rating) ? '#ffd700' : 'none'}
                        />
                      ))}
                    </div>
                    <span style={{ color: '#4a5568', fontWeight: 600 }}>{author.rating}</span>
                  </div>

                  {/* Stats */}
                  <div style={{ 
                    background: 'linear-gradient(135deg, #f7fafc 0%, #edf2f7 100%)',
                    borderRadius: '12px', 
                    padding: '20px',
                    marginBottom: '25px'
                  }}>
                    <div style={{ 
                      display: 'grid', 
                      gridTemplateColumns: 'repeat(3, 1fr)', 
                      gap: '20px', 
                      textAlign: 'center' 
                    }}>
                      <div>
                        <div style={{ 
                          fontSize: '1.8rem', 
                          fontWeight: 700, 
                          color: '#667eea',
                          marginBottom: '4px'
                        }}>
                          {author.publications}
                        </div>
                        <div style={{ fontSize: '0.85rem', color: '#718096', fontWeight: 600 }}>
                          Publications
                        </div>
                      </div>
                      <div>
                        <div style={{ 
                          fontSize: '1.8rem', 
                          fontWeight: 700, 
                          color: '#48bb78',
                          marginBottom: '4px'
                        }}>
                          {author.citations.toLocaleString()}
                        </div>
                        <div style={{ fontSize: '0.85rem', color: '#718096', fontWeight: 600 }}>
                          Citations
                        </div>
                      </div>
                      <div>
                        <div style={{ 
                          fontSize: '1.8rem', 
                          fontWeight: 700, 
                          color: '#ed8936',
                          marginBottom: '4px'
                        }}>
                          {author.hIndex}
                        </div>
                        <div style={{ fontSize: '0.85rem', color: '#718096', fontWeight: 600 }}>
                          H-Index
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Specialization */}
                  <div style={{ 
                    backgroundColor: '#667eea10',
                    borderRadius: '8px',
                    padding: '12px',
                    marginBottom: '25px'
                  }}>
                    <p style={{ 
                      fontSize: '0.95rem', 
                      color: '#4a5568', 
                      fontWeight: 500,
                      margin: 0,
                      lineHeight: '1.4'
                    }}>
                      <strong>Specialization:</strong> {author.specialization}
                    </p>
                  </div>

                  {/* Awards */}
                  <div style={{ marginBottom: '30px' }}>
                    <div style={{ 
                      display: 'flex', 
                      flexWrap: 'wrap', 
                      gap: '8px', 
                      justifyContent: 'center' 
                    }}>
                      {author.awards.map((award, awardIndex) => (
                        <span key={awardIndex} style={{
                          backgroundColor: '#ffd700',
                          color: '#744210',
                          padding: '4px 12px',
                          borderRadius: '12px',
                          fontSize: '0.8rem',
                          fontWeight: 600
                        }}>
                          🏆 {award}
                        </span>
                      ))}
                    </div>
                  </div>

                  {/* Action Buttons */}
                  <div style={{ display: 'flex', gap: '12px', justifyContent: 'center' }}>
                    
                    
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Join Community CTA */}
        <div style={{ 
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          padding: '3px',
          borderRadius: '20px',
          boxShadow: '0 20px 60px rgba(102, 126, 234, 0.3)'
        }}>
          <div style={{
            backgroundColor: 'white',
            borderRadius: '17px',
            padding: '60px 40px',
            textAlign: 'center'
          }}>
            <h2 style={{ 
              color: '#2d3748', 
              fontSize: '2.5rem', 
              fontWeight: 700, 
              marginBottom: '20px' 
            }}>
              Join Our Distinguished Community
            </h2>
            <p style={{ 
              color: '#718096', 
              fontSize: '1.2rem',
              marginBottom: '40px', 
              maxWidth: '700px', 
              margin: '0 auto 40px',
              lineHeight: '1.6'
            }}>
              Become part of our prestigious network of researchers and academics. Share your expertise, 
              collaborate with leading minds, and contribute to groundbreaking research that shapes the future.
            </p>
            <div style={{ 
              display: 'flex', 
              gap: '20px', 
              justifyContent: 'center', 
              flexWrap: 'wrap' 
            }}>
              <button style={{
                padding: '18px 40px',
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                color: 'white',
                border: 'none',
                borderRadius: '30px',
                fontSize: '1.1rem',
                fontWeight: 700,
                cursor: 'pointer',
                transition: 'transform 0.2s ease',
                display: 'flex',
                alignItems: 'center',
                gap: '10px'
              }}
              onMouseEnter={(e) => e.target.style.transform = 'translateY(-2px)'}
              onMouseLeave={(e) => e.target.style.transform = 'translateY(0)'}>
                <ExternalLink size={20} />
                Apply for Membership
              </button>
              <button style={{
                padding: '18px 40px',
                backgroundColor: 'white',
                color: '#667eea',
                border: '2px solid #667eea',
                borderRadius: '30px',
                fontSize: '1.1rem',
                fontWeight: 700,
                cursor: 'pointer',
                transition: 'all 0.2s ease'
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = '#667eea';
                e.target.style.color = 'white';
                e.target.style.transform = 'translateY(-2px)';
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = 'white';
                e.target.style.color = '#667eea';
                e.target.style.transform = 'translateY(0)';
              }}>
                Learn More
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Authors;